import styled from '@emotion/styled'

export const FONT_FAMILY = "'Open Sans', 'Helvetica Neue', sans-serif"

// Shared by the arcs and rows so each donut lines up with its value box.
export const BOX_PAIR_MAX_WIDTH = 520
export const BOX_GAP = 64

export const GUTTER_LABEL_MAX_WIDTH = 175
export const GUTTER_GAP = 20

export const Accent = styled.span`
  color: ${p => p.theme.primaryColor};
`

export const Chevron = ({ className }) => (
  <svg
    className={className}
    width='9'
    height='16'
    viewBox='0 0 9 16'
    fill='none'
    aria-hidden='true'>
    <path
      d='M1.5 1.5 L7.5 8 L1.5 14.5'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
